import * as React from 'react';
import { colors } from '../../../index';

const IconSent = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 18 14",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.17 3.745V0L.56 6.554l6.61 6.553V9.27c4.723 0 8.029 1.498 10.39 4.774-.945-4.68-3.778-9.362-10.39-10.298z",
    fill: "currentColor"
  }));
};

export default IconSent;